import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requireAnyPermission } from '@/features/auth/utils/permissionGuard';
import { QUESTION_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { MonitorBoardBreakdownPage } from '@/features/question/pages/MonitorBoardBreakdownPage';
import { monitorDistrictsSearchSchema } from '@/features/question/types/question.types';

export const Route = createFileRoute('/_auth/question/monitor/districts')({
  beforeLoad: () =>
    requireAnyPermission(
      QUESTION_PERMISSIONS.DOWNLOAD_VIEW,
      QUESTION_PERMISSIONS.DOWNLOAD_BY_BOARD_VIEW,
      QUESTION_PERMISSIONS.DOWNLOAD_BY_CLASS_VIEW,
    ),
  validateSearch: monitorDistrictsSearchSchema,
  component: function MonitorDistrictsRoute() {
    const search = Route.useSearch();
    return (
      <ErrorBoundary moduleName="District wise Question Monitor">
        <Suspense fallback={<PageLoader />}>
          <MonitorBoardBreakdownPage groupBy="zilla" search={search} />
        </Suspense>
      </ErrorBoundary>
    );
  },
});
